import { PhoneValidationResult } from '../core/sms';
import { HttpClient } from './http';

export interface SmsComplianceService {
  validatePhoneNumbers: (
    phoneNumbers: string[],
  ) => Promise<PhoneValidationResult[]>;
}

export function createSmsComplianceService(
  httpClient: HttpClient,
  baseUrl: string,
): SmsComplianceService {
  return {
    validatePhoneNumbers: (phoneNumbers: string[]) => {
      return httpClient<PhoneValidationResult[]>(
        `${baseUrl}/sms/compliance/validate-phone-numbers`,
        'get',
        { query: { phoneNumbers: (phoneNumbers || []).join(',') } },
      );
    },
  };
}
